import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useStyle } from 'shared/customHooks'

const MARKETO_AUTOFILL_FIELDS = {
  firstName: "FirstName",
  lastName: "LastName",
  email: "Email",
  company: "Company",
  phone: "Phone",
  country: "Country",
  state: "State"
}

const MARKETO_TO_SYSTEM_FIELDS_MAPPING = {
  'FirstName': 'name',
  'LastName': 'last_name'
}

const MarketoForm = (props) => {
  const themeColor = useSelector(state => state.campaign.themeColorHex)

  const { base_url, form_id, munchkin_id, custom_script } = props.config.form
  const marketoFormButtonClassPath =
    `.marketo-embedded-form .marketo-form-container.mktoForm .mktoButtonRow .mktoButtonWrap button`

  useStyle(
    `${marketoFormButtonClassPath} {
      background-color: ${themeColor}
    }`
  )

  const formAutoFillData = {
    [MARKETO_AUTOFILL_FIELDS.firstName]: props.autoFillData.name,
    [MARKETO_AUTOFILL_FIELDS.lastName]: props.autoFillData.last_name,
    [MARKETO_AUTOFILL_FIELDS.email]: props.autoFillData.email,
    [MARKETO_AUTOFILL_FIELDS.company]: props.autoFillData.company,
    [MARKETO_AUTOFILL_FIELDS.phone]: props.autoFillData.phone,
    [MARKETO_AUTOFILL_FIELDS.country]: props.autoFillData.country,
    [MARKETO_AUTOFILL_FIELDS.state]: props.autoFillData.state
  }

  useEffect(() => {
    tryCallMarketoApi(() => {
      MktoForms2.loadForm(base_url, munchkin_id, form_id, function(form) {

        form.vals(formAutoFillData)

        if (custom_script) {
          eval(custom_script)
        }

        const formAttributes = Object.keys(form.vals())
        const formFields = formAttributes.filter(
          attr => attr != 'formid' && attr != 'munchkinId'
        )

        form.onSuccess(function(values, followUpUrl) {
          const formFieldsToSubmit = formFields.map(
            field => updateMarketoFieldToSystemField(field, values)
          )

          handleOnSubmit(values, formFieldsToSubmit)

          // Return false to prevent the submission handler from taking the lead to the follow up url
          return false;
        });
      })
    })
  }, [])

  useEffect(() => {
    tryCallMarketoApi(() => {
      MktoForms2.whenReady(function(form) {
        // remove form id to prevent form duplicating when rendering the same form in a different place
        const formEl = form.getFormElem()[0]
        formEl.id = ""
      })
    })
  }, [])

  const tryCallMarketoApi = (marketoApiCall, numOfTries) => {
    numOfTries = numOfTries || 1

    if (typeof MktoForms2 !== 'undefined') {
      marketoApiCall()
    } else if (numOfTries <= 3) {
      setTimeout(() => { tryCallMarketoApi(marketoApiCall, numOfTries + 1) }, 1000)
    }
  }

  const lowercaseFirstLetter = function(string) {
    return string.charAt(0).toLowerCase() + string.slice(1)
  }

  const updateMarketoFieldToSystemField = (field, values) => {
    const systemField = MARKETO_TO_SYSTEM_FIELDS_MAPPING[field] || lowercaseFirstLetter(field)
    values[systemField] = values[field]
    delete values[field]
    return systemField
  }

  const formRedirectToOnSubmit = props.config.metadata.submit_redirect_url
  const formSuccessMessage = props.config.metadata.success_message

  const handleOnSubmit = (values, formFieldsToSubmit) => {
    props.onSubmit(
      values,
      formFieldsToSubmit,
      formSuccessMessage,
      formRedirectToOnSubmit
    )
  }

  const formTitle = props.config.metadata.title

  return (
    <section className="marketo-embedded-form">
      { formTitle && <h1>{formTitle}</h1> }
      <form id={`mktoForm_${form_id}`} className="marketo-form-container"/>
    </section>
  )
}

MarketoForm.propTypes = {
  config: PropTypes.object.isRequired,
  autoFillData: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired
}

export default MarketoForm
